import actions from '@/core/store/item-ata/bloqueio/historico/actions'
import state from '@/core/store/item-ata/bloqueio/historico/state'
import mutations from '@/core/store/item-ata/bloqueio/historico/mutations'

export default { actions, state, mutations }
